/**
 * created by xcc on 2021/3/14
 * 媒体管理批量组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MediaAdministerBatchAdd from "./MediaAdministerBatchAdd";
import {getInfoFromLocalStorage} from "../../../actions";

export default class MediaAdministerBatchComponent extends Component {
    static defaultProps = {}
    static propTypes = {
        title: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            currentLocationKey: "",
            currentLocationName: "",
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        let params = getInfoFromLocalStorage("MediaAdministerBatchAddComponent");
        if (params) {
            this.state.currentLocationKey = params.key;
            this.state.currentLocationName = params.name;
            this.setState({})
        }
    }

    render() {
        let margin = 15;
        let height = window.innerHeight - 90 - margin;
        return (
            <div style={{backgroundColor: "#fff", marginTop: margin, paddingBottom: margin, borderRadius: 5}}>
                <div style={{
                    padding: "10px 32px 10px 24px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #e3e0e0"
                }}>
                    <div style={{fontSize: 18, fontWeight: "bold"}}>{this.state.currentLocationName}</div>
                    <div>当前位置：媒体管理 > <span style={{color: "#1890ff"}}>{this.state.currentLocationName}</span><span
                        style={{margin: "0px 10px"}}>|</span><span onClick={() => {
                        this.mediaAdministerBatchAdd.exit()
                    }} style={{
                        color: "#1890ff",
                        cursor: "pointer"
                    }}>返回上一级</span></div>
                </div>
                {
                    (() => {
                        switch (this.state.currentLocationKey) {
                            case "MediaAdministerBatchAddComponent" :
                                return <MediaAdministerBatchAdd ref={(c) => this.mediaAdministerBatchAdd = c} title={"批量新增"} goBack={() => {
                                    this.props.history.push("/view/sys/mediaAdminister/true");
                                }}/>;
                            default:
                                return null
                        }
                    })()
                }
            </div>
        )
    }
}